import { SimpleCallback } from 'platform-components';

import * as constants from './constants';
import { PAGES } from './new-year-modal.constants';

export const renameClassRequest = () => <const>{ type: constants.RENAME_CLASS_REQUEST };

export const renameClassSuccess = () => <const>{ type: constants.RENAME_CLASS_SUCCESS };

export const renameClassError = () => <const>{ type: constants.RENAME_CLASS_ERROR };

export const setPage = (page: PAGES) => <const>{ type: constants.SET_PAGE, page };

export const archiveClassRequest = () => <const>{ type: constants.ARCHIVE_CLASS_REQUEST };

export const archiveClassSuccess = () => <const>{ type: constants.ARCHIVE_CLASS_SUCCESS };

export const archiveClassError = () => <const>{ type: constants.ARCHIVE_CLASS_ERROR };

export const setNewName = (name: string) => <const>{ type: constants.SET_NEW_NAME, name };

export const setNewLevel = (level: number) => <const>{ type: constants.SET_NEW_LEVEL, level };

export const actualizeClassRequest = (onAfterActualize?: SimpleCallback) =>
    <const>{ type: constants.ACTUALIZE_CLASS_REQUEST, onAfterActualize };

export const actualizeClassSuccess = () => <const>{ type: constants.ACTUALIZE_CLASS_SUCCESS };

export const actualizeClassError = () => <const>{ type: constants.ACTUALIZE_CLASS_ERROR };

export const closeModal = (classId: number) => <const>{ type: constants.CLOSE_MODAL, classId };

export const clearState = () => <const>{ type: constants.CLEAR_STATE };

export const archiveTeam = (onAfterArchive?: (classId: number) => void) =>
    <const>{ type: constants.ARCHIVE_TEAM, onAfterArchive };

export const renameTeam = (onAfterRename?: SimpleCallback) => <const>{ type: constants.RENAME_TEAM, onAfterRename };
